import { render, staticRenderFns } from "./DeleteContentModal.vue?vue&type=template&id=d3579b10&scoped=true"
import script from "./DeleteContentModal.vue?vue&type=script&lang=js"
export * from "./DeleteContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3579b10",
  null
  
)

export default component.exports